import { QuillModule } from 'ngx-quill';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatBadgeModule } from '@angular/material/badge';
import { ConfirmationPopoverModule } from '@shared/libs/angular-confirmation-directive/confirmation-popover.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AttachmentsModule } from '@shared/modules/attachments/attachments.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPrettyCheckboxModule } from 'ngx-pretty-checkbox';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

export const SHARED_MODULES = [
  CommonModule,
  TranslateModule,
  RouterModule,
  CoreModule,
  QuillModule,
  MatMenuModule,
  MatTabsModule,
  MatIconModule,
  MatDialogModule,
  MatSidenavModule,
  MatBadgeModule,
  MatCardModule,
  MatButtonModule,
  MatDatepickerModule,
  ConfirmationPopoverModule,
  AngularSvgIconModule,
  AttachmentsModule,
  NgxPrettyCheckboxModule,
  ImageCropperComponent,
  MatFormFieldModule,
  MatInputModule,
  MatDatepickerModule,
  MatTooltipModule
];
